import {FORM_STEP_KEY, FORM_STEP_ORDER} from '../constant/FormStep';

const CONTACT_FORM_ID = 'contact';

/**
 * Google Analytics 4 events for the contact form.
 *
 * The tag itself is set up in templates/includes/analytics.html, which scripts/integrate.py
 * injects into the generated page (see public/index.html). Nothing here configures gtag --
 * this only sends events, and stays silent when no property is configured.
 */
class AnalyticsService {
  /**
   * Everything goes through the page's qtrack(), the same entry point the rest of the site
   * uses, because that is where the consent gate lives -- it re-reads the cookie on every
   * call, so withdrawing consent mid-form stops the very next step advance.
   *
   * Checking window.gtag or the measurement id here instead was the bug: both stay truthy
   * after a withdrawal, so the form kept reporting to Google with the banner saying it had
   * been switched off.
   *
   * Under `npm start` there is no Django and so no analytics.html, which leaves qtrack
   * undefined and drops us through to the console -- which is what lets instrumentation be
   * verified locally.
   */
  static track (name, params = {}) {
    if (typeof window.qtrack !== 'function') {
      console.debug('[qtrack]', name, params);

      return;
    }

    window.qtrack(name, params);
  }

  /**
   * Called as each step is left behind. step_index drives the funnel exploration in GA4,
   * which orders stages numerically -- step_name alone would sort alphabetically and
   * scramble the funnel.
   */
  static trackFormStep (step) {
    if (step === FORM_STEP_KEY.HOME) {
      AnalyticsService.track('form_start', {form_id: CONTACT_FORM_ID});
    }

    AnalyticsService.track('form_step', {
      form_id   : CONTACT_FORM_ID,
      step_name : step,
      step_index: FORM_STEP_ORDER.indexOf(step)
    });
  }

  /**
   * The conversion. Fired only once the API has accepted the submission, so it counts
   * leads that actually reached the team rather than submit-button clicks.
   *
   * lead_source mirrors settings.LEAD_SOURCE on the Django side so GA4 totals can be
   * reconciled against the leads recorded there.
   */
  static trackLead () {
    AnalyticsService.track('generate_lead', {
      form_id    : CONTACT_FORM_ID,
      lead_source: 'contact_form'
    });
  }

  static trackSubmitError (error) {
    AnalyticsService.track('form_submit_error', {
      form_id: CONTACT_FORM_ID,
      error  : String(error)
    });
  }
}

export default AnalyticsService;
